import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { computed } from 'mobx';
import { Box, ButtonLink, Flex, FlexColumn, Text } from 'core/components';
import { VirtualizedTable } from 'core/components/table';
import { ALERT_SEVERITIES } from '@kentik/ui-shared/alerting/constants';
import { formatAlertCount } from 'app/views/alerting/util/formatting';
import AlertSeverityBars from './AlertSeverityBars';

@observer
class AlertingSiteHealthTable extends Component {
  @computed
  get summaryTotals() {
    const { collection } = this.props;
    const totalCounts = {
      critical: 0,
      major2: 0,
      major: 0,
      minor2: 0,
      minor: 0
    };

    collection.models.forEach((model) => {
      const severities = model.get('severities');
      ALERT_SEVERITIES.forEach((severity) => {
        totalCounts[severity] += severities[severity];
      });
    });

    return totalCounts;
  }

  getColumns() {
    const { navigateToSiteFilterView, groupBy } = this.props;

    let columns = [
      {
        label: (
          <Box>
            {groupBy === 'severity' && (
              <Text as="div" fontSize={18}>
                &nbsp;
              </Text>
            )}
            <Text>Site</Text>
          </Box>
        ),
        name: 'title',
        alignItems: 'flex-end',
        width: 120,
        ellipsis: true,
        padding: '6px 0px 6px 0px',
        renderer: ({ model, value }) => (
          <ButtonLink onClick={() => navigateToSiteFilterView(model.id)} ellipsis>
            {value}
          </ButtonLink>
        )
      }
    ];

    if (groupBy === 'none') {
      columns.push({
        label: 'Total Alerts',
        name: 'totalCount',
        ellipsis: false,
        sortable: true,
        computed: true,
        renderer: ({ value }) => {
          const alertCount = Number(value);
          return (
            <Text small muted={alertCount === 0}>
              {formatAlertCount(alertCount)}
            </Text>
          );
        }
      });
    }

    if (groupBy === 'severity') {
      const severityColumns = ALERT_SEVERITIES.map((severity) => ({
        label: (
          <Box>
            <Text as="div" fontSize={18} fontWeight={700} textAlign="right">
              {formatAlertCount(this.summaryTotals[severity])}
            </Text>
            <Flex alignItems="center" gap="4px" justifyContent="flex-end">
              <AlertSeverityBars severity={severity} small />
            </Flex>
          </Box>
        ),
        name: severity,
        justifyContent: 'flex-end',
        ellipsis: false,
        sortable: false,
        minWidth: 75,
        padding: '6px 0px 6px 12px',
        renderer: ({ model }) => {
          const alertCount = Number(model.get(`severities.${severity}`));
          return (
            <Text small muted={alertCount === 0}>
              {formatAlertCount(alertCount)}
            </Text>
          );
        }
      }));

      columns = columns.concat(severityColumns);
    }

    return columns;
  }

  render() {
    const { collection, loading } = this.props;

    return (
      <FlexColumn height="100%">
        <VirtualizedTable
          width="100%"
          collection={collection}
          headerStyle={{
            alignItems: 'center',
            fontSize: '14px'
          }}
          loading={loading}
          useSortTooltips
          noHighlightSorted
          columns={this.getColumns()}
          selectOnRowClick={false}
          flexed
          rowHeight={28}
        />
      </FlexColumn>
    );
  }
}

export default AlertingSiteHealthTable;
